import React from 'react';

const AgentPreferredOffice = () => {
  return (
    <svg width="250" height="120" viewBox="0 0 250 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M136 25a7 7 0 1 1 0 14h64a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-19a7 7 0 1 0 0 14h6a7 7 0 1 1 0 14h-52a7 7 0 0 1-1.5-.161A7 7 0 0 1 154 95H63a7 7 0 1 1 0-14H24a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H39a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm90 56a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
        fill="#eceff1"
      />
      <rect x="110.749" y="45.066" width="67" height="64.305" rx="7" fill="#fff" />
      <path
        d="M121.985 45.067c6.05 26.244 28.367 46.267 55.764 48.884v8.42a7 7 0 0 1-7 7h-53a7 7 0 0 1-7-7V52.067a7 7 0 0 1 7-7z"
        fill="#eceff1"
      />
      <path
        d="M116.73 45.277h-2.427c-1.506 0-2.727 1.234-2.727 2.758v57.923c0 1.524 1.221 2.759 2.727 2.759h60.009c1.506 0 2.728-1.235 2.728-2.759V48.035c0-1.524-1.222-2.758-2.728-2.758h-25.438"
        stroke="#90a4ae"
      />
      <path
        d="M155.374 69.393h12.573a1 1 0 0 1 1 1v6.674a1 1 0 0 1-1 1h-12.573zm0-15.25h12.573a1 1 0 0 1 1 1v6.673a1 1 0 0 1-1 1h-12.573z"
        fill="#eceff1"
      />
      <rect x="138.874" y="54.478" width="30.461" height="8.225" rx="1" stroke="#90a4ae" />
      <rect x="138.874" y="69.535" width="30.461" height="8.225" rx="1" stroke="#90a4ae" />
      <rect x="78.374" y="23.261" width="67" height="86.305" rx="7" fill="#fff" />
      <path
        d="M98.249 23.543h43.688c1.506 0 2.728 1.658 2.728 3.702v77.741c0 2.044-1.222 3.701-2.728 3.701H81.928c-1.506 0-2.727-1.657-2.727-3.701v-77.74c0-2.045 1.22-3.703 2.727-3.703h2.427m4.894 0h3.875"
        stroke="#90a4ae"
      />
      <rect x="87.072" y="33.666" width="12" height="17" rx="1" fill="#fff" />
      <rect x="87.072" y="57.997" width="12" height="17" rx="1" fill="#fff" />
      <rect x="106.016" y="33.666" width="12" height="17" rx="1" fill="#fff" />
      <rect x="106.016" y="57.997" width="12" height="17" rx="1" fill="#fff" />
      <rect x="124.959" y="33.666" width="12" height="17" rx="1" fill="#fff" />
      <rect x="124.959" y="57.997" width="12" height="17" rx="1" fill="#fff" />
      <path
        d="M112.064 57.643h4.008a1 1 0 0 1 1 1v15.012a1 1 0 0 1-1 1h-4.008zm0-23.859h4.008a1 1 0 0 1 1 1v15.012a1 1 0 0 1-1 1h-4.008zm18.999 23.859h4.008a1 1 0 0 1 1 1v15.012a1 1 0 0 1-1 1h-4.008zm0-23.859h4.008a1 1 0 0 1 1 1v15.012a1 1 0 0 1-1 1h-4.008zM93.065 57.643h4.008a1 1 0 0 1 1 1v15.012a1 1 0 0 1-1 1h-4.008zm0-23.859h4.008a1 1 0 0 1 1 1v15.012a1 1 0 0 1-1 1h-4.008z"
        fill="#eceff1"
      />
      <rect x="87.072" y="33.666" width="12" height="17" rx="1" stroke="#90a4ae" />
      <rect x="87.072" y="57.997" width="12" height="17" rx="1" stroke="#90a4ae" />
      <rect x="106.016" y="33.666" width="12" height="17" rx="1" stroke="#90a4ae" />
      <rect x="106.016" y="57.997" width="12" height="17" rx="1" stroke="#90a4ae" />
      <rect x="124.959" y="33.666" width="12" height="17" rx="1" stroke="#90a4ae" />
      <rect x="124.959" y="57.997" width="12" height="17" rx="1" stroke="#90a4ae" />
      <path d="M97.949 83.215h14.245v24.807H97.949z" fill="#fff" stroke="#90a4ae" />
      <path d="M112.05 83.215h14.246v24.807H112.05z" fill="#fff" stroke="#90a4ae" />
      <path d="M107.874 94.442v2.5m8.062-2.5v2.5" stroke="#b0bec5" />
      <path d="M62.561 108.692h20.454m-33.326 0h6.872m140.878 0h2.872m-28 0h20.428" stroke="#90a4ae" />
    </svg>
  );
};

export default AgentPreferredOffice;
